import React,{useEffect, useState} from 'react'
import './style.css';
import { Link, useParams } from 'react-router-dom'
import { useSelector , useDispatch} from 'react-redux';
import currencyFormatter from 'currency-formatter'

const Details = () => {

    const {id} = useParams();
    const dispatch = useDispatch();
    
    const {newProduct} = useSelector(state => state.allprodcuts)
    useEffect(() => {
        dispatch({type:"DETAILS", id:id})
    },[id])
  
    const [quantity, setQuantity] = useState(1);

    const decQuantity = () => {
        if(quantity > 1){
            setQuantity(quantity-1)
        }
    }
    
    return (
        <div className="details">
           <div className="container">
               <div className="row">
                <div className="col-sm-12" key={newProduct.id}>
                    <div className="details-content">
                        <div className="details-img">
                           <img src={newProduct.image} alt={newProduct.title} />
                        </div>

                        <div className="details-desc">
                            <h3>{newProduct.title}</h3>
                            <div className="product-icons">
                                <i className="fa fa-star"></i>
                                <i className="fa fa-star"></i>
                                <i className="fa fa-star"></i>
                                <i className="fa fa-star"></i>
                                <i className="fa fa-star"></i>            
                            </div>
                            <p>{newProduct.desc}</p>
                        </div>

                        <div className="details-info">
                            <p>{currencyFormatter.format(newProduct.price, { code: 'USD' })}</p>
                            <div className="counter">
                            <span onClick={decQuantity}>-</span>
                            <span>{quantity}</span>
                            <span onClick={()=>setQuantity(quantity+1)}>+</span>
                            </div>
                            <button onClick={()=> dispatch({type:'ADD', payload:{newProduct, quantity}})}>add to cart</button>
                            <Link to="/">Back</Link>
                        </div>
                    </div>
                    </div>
               </div>
           </div>
        </div>
    )
}

export default Details


